import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQuizLogoutMutation } from "../../slices/fun_stuff/quizUsersSlice";
import { quizLogout } from "../../slices/fun_stuff/quizAuthSlice";
import { Button } from "react-bootstrap";
import QuizLogin from "./QuizLogin";
import QuizRegister from "./QuizRegister";
import UpdateInfo from "./UpdateInfo";
import GeneralFeedback from "./GeneralFeedback";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faRightFromBracket, faPenToSquare, faChevronUp, faChessBoard, faComment, faUserTie } from '@fortawesome/free-solid-svg-icons';


const QuizHeader = ({ profile }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showUpdateInfo, setShowUpdateInfo] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const { quizUserInfo } = useSelector((state) => state.quizAuth);

  const [logoutApiCall] = useQuizLogoutMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = async () => {
    try {
      navigate("/quizgame");
      await logoutApiCall().unwrap();
      dispatch(quizLogout());
    } catch (error) {
      console.log(error);
    }
  }

  return (
  <div className="p-1 bg-light rounded shadow-sm">
    {quizUserInfo ? (
      <>
        <div className="c-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">

          <h4 className="mb-4 text-header">Welcome, {quizUserInfo.username}!</h4>

          {quizUserInfo.is_admin &&
          <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
            <Button
              onClick={() => navigate('/quizgame/admin')}
              className="quiz-btn-dark py-1 px-3"
            >
              <FontAwesomeIcon icon={faUserTie} className="me-2" />
              Admin
            </Button>

            <Button
              onClick={() => {
                setShowRegister(!showRegister);
                setShowLogin(false);
                setShowFeedback(false);
                setShowUpdateInfo(false);
              }}
              className="quiz-btn-dark py-1 px-3"
            >
              {!showRegister ? 'Register' : <>Hide Register <FontAwesomeIcon icon={faChevronUp} className="ms-1"/></>}
            </Button>
          </div>}

          <div className="d-flex flex-wrap gap-4 justify-content-center">
            {profile ? (
              <Button
                onClick={() => navigate('/quizgame')}
                className="quiz-btn-dark py-1 px-3"
              >
                <FontAwesomeIcon icon={faChessBoard} className="me-2"/>
                Back to Game
              </Button>
            ) : (
              <Button
                onClick={() => navigate('/quizgame/quizprofile')}
                className="quiz-btn-dark py-1 px-3"
              >
                <FontAwesomeIcon icon={faUser} className="me-2" />
                Profile
              </Button>
            )}

            <Button
              className="quiz-btn-dark py-1 px-3"
              onClick={logoutHandler}
            >
              <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
              Logout
            </Button>

            <Button
              onClick={() => {
                setShowUpdateInfo(!showUpdateInfo);
                setShowFeedback(false);
              }}
              className="quiz-btn-dark py-1 px-3"
            >
              {!showUpdateInfo ? <><FontAwesomeIcon icon={faPenToSquare} className="me-2"/>Update Profile</> : <>Hide update profile <FontAwesomeIcon icon={faChevronUp} className="ms-1"/></>}
            </Button>

            <Button className="quiz-btn-dark" onClick={() => {
              setShowFeedback(!showFeedback);
              setShowUpdateInfo(false);
            }}>
                {!showFeedback ? 
                <>
                <FontAwesomeIcon icon={faComment} className="me-2" />Give Feedback
                </>
                  : 
                  <>
                Hide Feedback<FontAwesomeIcon icon={faChevronUp} className="ms-1" />
                  </>}
            </Button>
          </div>
        </div>
      </>
    ) : (
      <>
        <h4 className="text-header">Welcome, Guest!</h4>
        <p className="text-muted text-center">
          Want to save your progress and show your idiot friends how smart you are?
        </p>
        <div className="d-flex flex-wrap align-items-center gap-2 justify-content-center">
          <Button
            onClick={() => {
              setShowLogin(!showLogin);
              setShowRegister(false);
              setShowFeedback(false);
            }}
            className="quiz-btn-dark py-1 px-3"
          >
            {!showLogin ? 'Login' : <>Hide Login <FontAwesomeIcon icon={faChevronUp} className="ms-1"/></>}
          </Button>
          <span className="text-muted">or</span>
          <Button
            onClick={() => {
              setShowRegister(!showRegister);
              setShowLogin(false);
              setShowFeedback(false);
            }}
            className="quiz-btn-dark py-1 px-3"
          >
            {!showRegister ? 'Register' : <>Hide Register <FontAwesomeIcon icon={faChevronUp} className="ms-1"/></>}
          </Button>

        </div>
        <div className="d-flex flex-wrap align-items-center justify-content-center my-3">
          <Button className="quiz-btn-dark" onClick={() => {
            setShowFeedback(!showFeedback);
            setShowRegister(false);
            setShowLogin(false)}}
          >
            {!showFeedback ? 
            <>
            <FontAwesomeIcon icon={faComment} className="me-2" />Give Feedback
            </>
              : 
              <>
            Hide Feedback<FontAwesomeIcon icon={faChevronUp} className="ms-1" />
              </>}
          </Button>
        </div>
      </>
    )}
      <div className="mt-3 d-flex flex-column align-items-center">
        {showLogin && <QuizLogin setShow={setShowLogin} />}
        {showRegister && <QuizRegister setShow={setShowRegister} />}
        {showFeedback && <GeneralFeedback />}
        {showUpdateInfo && <UpdateInfo setShow={setShowUpdateInfo} />}
      </div>
  </div>
  );
}

export default QuizHeader;